jQuery('document').ready(function($) {
    "use strict";

    var timeouts = [];

    $('.product__variations-form').on('submit', onFormSubmit);

    /**
     * Handles the form input and starts the validation
     * Will prevent default if any validation errors occur
     * @param {Event} e 
     */
    function onFormSubmit(e) {
        // Gets all the product variation selects, except the
        // addons (since they are not required)
        var failed = false;

        var $selects = $('.product__variation select:not(.addon)');
        $.each($selects, function(index, select) {
            if(select.value.length === 0) {
                failed = true;
                flashSelect(select);
            }
        });

        if(failed) {
            e.preventDefault();
        }
    }

    /**
     * Applies a class to the provided selects parent element
     * which will cause the element to flash
     * @param {any} select 
     */
    function flashSelect(select) {
        var $parent = $(select.parentElement);
        $parent.addClass('product__variation--failed-validation');

        var currentTimeout = getTimeout(select);
        if(currentTimeout != null) {
            removeTimeout(select);
        }

        addTimeout(select, setTimeout(resetFailedValidation.bind(window, select), 400));
    }

    /**
     * Resets the provided selects parent element
     * 
     * @param {any} select 
     */
    function resetFailedValidation(select) {
        removeTimeout(select);
        var $parent = $(select.parentElement);
        $parent.removeClass('product__variation--failed-validation');
    }

    /**
     * Add a timeout to the timeout list
     * 
     * @param {any} select 
     * @param {any} timeout 
     */
    function addTimeout(select, timeout) {
        timeouts.push({
            id: select,
            timeout: timeout
        });
    }

    /**
     * Get a timeout from the timeout list
     * 
     * @param {any} select 
     * @returns 
     */
    function getTimeout(select) {
        for(var i = 0, l = timeouts.length; i < l; ++i) {
            if(timeouts[i].id === select) {
                return timeouts[i];
            }
        }

        return null;
    }

    /**
     * Removes a timeout from the timeout list
     * 
     * @param {any} select 
     */
    function removeTimeout(select) {
        for(var i = timeouts.length - 1; i > 0; --i) {
            if(timeouts[i].id === select) {
                timeouts.splice(i, 1);
            }
        }
    }

    /**
     * Fetches the selects default option
     * 
     * @param {HTMLSelectElement} select 
     * @returns {String} defaultOption
     */
    function getDefaultOption(select) {
        return $(select).find('option[value=""]').get(0).innerHTML;
    }
});